import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { isKeyPressed } from "../../../../../utils/isKeyPressed";
import { SPACEBAR_KEY_CODE, RETURN_KEY_CODE } from "../../../../../utils/Browser/keyCodes";
import { jsx as _jsx } from "react/jsx-runtime";
function SelectAll(_ref) {
  let {
    hide = false,
    onSelectAll
  } = _ref;
  const [hidden, setHide] = useState(hide);
  useEffect(() => {
    setHide(hide);
  }, [hide]);
  const handleKeyDown = e => {
    if (isKeyPressed(e, ' ', SPACEBAR_KEY_CODE) || isKeyPressed(e, 'Enter', RETURN_KEY_CODE)) {
      e.preventDefault();
      onSelectAll?.();
    }
  };
  const selectAllClass = cn('px-2.5 py-2 text-sm text-action-blue font-medium-font', {
    hidden
  });
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "select-all",
    className: selectAllClass,
    children: /*#__PURE__*/_jsx("span", {
      role: "button",
      tabIndex: 0,
      onClick: onSelectAll,
      onKeyDown: handleKeyDown,
      children: "Select All"
    })
  });
}
SelectAll.propTypes = {
  hide: PropTypes.bool,
  onSelectAll: PropTypes.func.isRequired
};
export default SelectAll;
//# sourceMappingURL=SelectAll.js.map